import { Text } from '@chakra-ui/react';
import CockpitDialog from '@components/cockpit/CockpitDialog';
import { useAppDispatch, useAppSelector } from '@hooks/redux.hooks';
import { useAuth } from '@hooks/useAuth';
import { useWithDispatch } from '@hooks/useWithDispatch';
import { updateForcedLogoutCause } from '@redux/authent/authent.reducer';
import { selectForcedLogoutCause } from '@redux/authent/authent.selectors';
import { useLogoutMutation } from '@services/authent/login.api';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMatch } from 'react-router';

import { LogoutCauseEnum } from '@/types/authent/login.types';
import { RoutesEnum } from '@/types/routes.types';

export default function HasBeenLoggedOutModal() {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const forcedLogoutCause = useAppSelector(selectForcedLogoutCause);
  const dispatchForcedLogoutCause = useWithDispatch(updateForcedLogoutCause);
  const [logoutMutation] = useLogoutMutation();
  const { token } = useAuth();
  const isCockpitRoute = useMatch(`${RoutesEnum.COCKPIT}/*`);
  const hasToLogout = forcedLogoutCause !== LogoutCauseEnum.NONE;

  useEffect(() => {
    if (isCockpitRoute && hasToLogout && !!token) {
      logoutMutation({ token, emptyStoreOnLogout: true });
    }
  }, [isCockpitRoute, hasToLogout, token, logoutMutation, dispatch]);

  return (
    <CockpitDialog
      open={hasToLogout}
      onConfirm={() => {
        dispatchForcedLogoutCause(LogoutCauseEnum.NONE);
      }}
      confirmLabel={formatMessage({ id: 'global.ok' })}
    >
      <Text textAlign="center">
        {hasToLogout && <FormattedMessage id={`authent.resetHeader.${forcedLogoutCause}`} />}
      </Text>
    </CockpitDialog>
  );
}
